import { Component } from '@angular/core';
import { UIRouter }  from '@uirouter/core';

import { LoginService }   from '../login/login.service';
import { SessionService } from '../../app-lite/sessions/session.service';

@Component({
  selector   : 'wor-navbar',
  styles: [ require('./navbar.component.scss') ],
  template: require('./navbar.component.html')
})
export class NavbarComponent {
  sessionId : string;

  constructor (
    private loginService  : LoginService,
    private router        : UIRouter,
    private sessionService: SessionService
  ) {}

  hasSession () {
    return !!this.sessionService.sessionID();
  }

  logout () {
    this.loginService.logout()
    .then(() => {
      this.router.stateService.go('ajs.app.public.login');
    });
  }
}
